var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32 64a23.58 23.58 0 0 0 9.24-1.87 1 1 0 1 0-.76-1.78 22 22 0 0 1-17 0 1 1 0 0 0-.76 1.78A23.58 23.58 0 0 0 32 64ZM9.38 37.45h.16a1 1 0 0 0 1-.81 21.62 21.62 0 0 1 6.09-11.8 1 1 0 1 0-1.37-1.37 23.57 23.57 0 0 0-6.67 12.87 1 1 0 0 0 .79 1.11ZM52.08 31.78a21.76 21.76 0 0 1 1.42 4.87 1 1 0 0 0 1 .81h.16a1 1 0 0 0 .79-1.11 23.57 23.57 0 0 0-6.63-12.86 1 1 0 1 0-1.37 1.37 21.4 21.4 0 0 1 4.63 6.92ZM48.3 46.46a5.72 5.72 0 1 0 5.7-5.71 5.73 5.73 0 0 0-5.7 5.71Zm9.49 0A3.78 3.78 0 1 1 54 42.69a3.77 3.77 0 0 1 3.79 3.77Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 52.49a10 10 0 0 0-10 10V63a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-.56a10 10 0 0 0-10-9.95Zm-8 9.57a8 8 0 0 1 16.06 0ZM32 11.43a5.72 5.72 0 1 0-5.71-5.71A5.72 5.72 0 0 0 32 11.43Zm0-9.49a3.78 3.78 0 1 1-3.78 3.78A3.78 3.78 0 0 1 32 1.94Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 23.25h18a1 1 0 0 0 1-1v-.56a10 10 0 1 0-20 0v.56a1 1 0 0 0 1 1Zm9-9.57a8 8 0 0 1 8 7.63H24a8 8 0 0 1 8-7.63ZM10 52.18a5.72 5.72 0 1 0-5.71-5.72A5.73 5.73 0 0 0 10 52.18Zm0-9.49a3.78 3.78 0 1 1-3.77 3.77A3.78 3.78 0 0 1 10 42.69Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 64h18a1 1 0 0 0 1-1v-.56a10 10 0 0 0-20 0V63a1 1 0 0 0 1 1Zm9-9.57a8 8 0 0 1 8 7.63H2a8.06 8.06 0 0 1 8-7.63ZM17 39.66l2.24 1a11.53 11.53 0 0 0 0 2l-2.26.91a1 1 0 0 0-.53.52 1 1 0 0 0 0 .75l2.27 5.62a1 1 0 0 0 1.26.54l2.19-1a15 15 0 0 0 1.37 1.39l-.95 2.24a1 1 0 0 0 .52 1.27l5.58 2.37a1 1 0 0 0 1.31-.53l.95-2.23a12.69 12.69 0 0 0 1.95 0l.92 2.26a1 1 0 0 0 .52.53 1 1 0 0 0 .38.07.92.92 0 0 0 .36-.07l5.58-2.3a1 1 0 0 0 .54-1.26l-.91-2.25a12.93 12.93 0 0 0 1.39-1.38l2.24 1a1 1 0 0 0 .74 0 1 1 0 0 0 .53-.52L47.56 45a1 1 0 0 0-.51-1.28l-2.24-.94a11.66 11.66 0 0 0 0-2l2.26-.91a1 1 0 0 0 .53-.52 1 1 0 0 0 0-.74L45.34 33a1 1 0 0 0-1.26-.53l-2.25.91A13.82 13.82 0 0 0 40.46 32l.95-2.24a1 1 0 0 0-.52-1.27l-5.58-2.37a1 1 0 0 0-.74 0 1 1 0 0 0-.53.52l-.95 2.23a12.69 12.69 0 0 0-2 0l-.92-2.26a.93.93 0 0 0-.52-.53 1 1 0 0 0-.74 0l-5.62 2.28a1 1 0 0 0-.54 1.26l.91 2.25a12.83 12.83 0 0 0-1.39 1.37l-2.24-1a1 1 0 0 0-1.27.51l-2.37 5.59a1 1 0 0 0 .61 1.32Zm3.27-5.21 2 .86a1 1 0 0 0 1.14-.3A11.31 11.31 0 0 1 25.46 33a1 1 0 0 0 .32-1.14l-.82-2 3.83-1.55.82 2a1 1 0 0 0 1 .6 11 11 0 0 1 2.92 0 1 1 0 0 0 1-.58l.85-2 3.8 1.61-.85 2a1 1 0 0 0 .3 1.14 11.31 11.31 0 0 1 2.06 2.09 1 1 0 0 0 1.14.32l2-.82 1.54 3.83-2 .82a1 1 0 0 0-.6 1 10.53 10.53 0 0 1 0 2.86v.09a1 1 0 0 0 .59 1l2 .85-1.61 3.8-2-.86a1 1 0 0 0-1.14.3 11 11 0 0 1-2.09 2.06 1 1 0 0 0-.32 1.14l.82 2-3.83 1.55-.82-2a1 1 0 0 0-.9-.61h-.12a11 11 0 0 1-2.92 0 1 1 0 0 0-1 .58l-.85 2-3.8-1.61.85-2a1 1 0 0 0-.3-1.15 11 11 0 0 1-2.06-2.08.94.94 0 0 0-1.13-.32l-2 .81-1.54-3.82 2-.82a1 1 0 0 0 .6-1 10.38 10.38 0 0 1 0-2.84.43.43 0 0 1 0-.11 1 1 0 0 0-.59-1l-2-.86Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 49.86a8.17 8.17 0 1 0-8.17-8.16A8.18 8.18 0 0 0 32 49.86Zm0-14.39a6.23 6.23 0 1 1-6.23 6.23A6.24 6.24 0 0 1 32 35.47Z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.d11aba5e82526f7897b8416860735fbd.svg";
export { ForwardRef as ReactComponent };